"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKMenuButton = void 0;
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var React = __importStar(require("react"));
var common_1 = require("../../common");
var components_1 = require("../../components");
/**
 * Component which provides similar (but simplified) functionality to Reactstrap's ButtonDropdown.
 */
var GKMenuButton = /** @class */ (function (_super) {
    __extends(GKMenuButton, _super);
    function GKMenuButton(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        // PRIVATE METHODS -------------------------------------
        _this.toggleOpen = function () {
            _this.setState({ isOpen: !_this.state.isOpen });
        };
        _this.onClosed = function () {
            if (_this.buttonRef.current && _this.state.isOpen) {
                _this.buttonRef.current.focus();
            }
            _this.closeTheMenu();
        };
        _this.onOpened = function () {
            if (_this.menuRef.current) {
                _this.menuRef.current.focus();
            }
        };
        _this.onButtonFocus = function (event) {
            _this.setState({ isButtonFocused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.onButtonBlur = function (event) {
            _this.setState({ isButtonFocused: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        // close menu if clicked, touched, or focused outside the component --
        _this.onClickOutside = function (event) {
            return _this.closeIfOutsideComponent(event.target);
        };
        _this.onTouchend = function (event) {
            return _this.closeIfOutsideComponent(event.changedTouches[0].target);
        };
        _this.onContainerBlur = function (event) {
            if (event.relatedTarget !== null) {
                _this.closeIfOutsideComponent(event.relatedTarget);
            }
        };
        _this.closeIfOutsideComponent = function (target) {
            var isMobileSized = _this.context.isMobileSized;
            var shouldClose = Boolean(_this.state.isOpen &&
                !isMobileSized &&
                _this.containerRef.current &&
                !_this.containerRef.current.contains(target));
            if (shouldClose) {
                _this.closeTheMenu();
            }
        };
        // --
        _this.closeTheMenu = function () {
            _this.setState({ isOpen: false });
        };
        _this.generalMouseDown = function () {
            _this.setState({ isClickInProgress: true });
        };
        _this.generalClick = function () {
            _this.setState({ isClickInProgress: false });
        };
        _this.state = {
            isButtonFocused: false,
            isClickInProgress: false,
            isOpen: false,
        };
        _this.containerId = _this.uniqueId + "-container";
        _this.menuId = _this.uniqueId + "-menu";
        _this.menuQaTag = ((_a = _this.props["data-qa"]) !== null && _a !== void 0 ? _a : "gk-menu-button") + "--menu";
        _this.buttonId = "" + _this.uniqueId;
        _this.containerRef = React.createRef();
        _this.menuRef = React.createRef();
        _this.buttonRef = React.createRef();
        return _this;
    }
    Object.defineProperty(GKMenuButton.prototype, "menuSnapshot", {
        get: function () {
            return this.menuRef.current;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GKMenuButton.prototype, "buttonSnapshot", {
        get: function () {
            return this.buttonRef.current;
        },
        enumerable: false,
        configurable: true
    });
    // COMPONENT LIFECYCLE --------------------------------------
    GKMenuButton.prototype.componentDidMount = function () {
        document.documentElement.addEventListener("touchend", this.onTouchend);
        document.documentElement.addEventListener("click", this.onClickOutside);
    };
    GKMenuButton.prototype.componentWillUnmount = function () {
        document.documentElement.removeEventListener("touchend", this.onTouchend);
        document.documentElement.removeEventListener("click", this.onClickOutside);
    };
    GKMenuButton.prototype.componentDidUpdate = function (oldProps, oldState) {
        this.containerId = this.uniqueId + "-container";
        this.menuId = this.uniqueId + "-menu";
        this.buttonId = "" + this.uniqueId;
        // edge case - if the button gains focus but the menu has lost it, close the menu
        if (!oldState.isButtonFocused &&
            this.state.isButtonFocused &&
            this.state.isOpen &&
            !this.state.isClickInProgress) {
            this.setState({ isOpen: false });
        }
    };
    GKMenuButton.prototype.render = function () {
        var _a = this.props, text = _a.text, icon = _a.icon, iconPosition = _a.iconPosition, children = _a.children, closeOnSelect = _a.closeOnSelect, compact = _a.compact, containerClassName = _a.containerClassName, fullscreenCloseText = _a.fullscreenCloseText, menuPlacement = _a.menuPlacement, tooltip = _a.tooltip, 
        // Destructure from otherProps
        /* eslint-disable @typescript-eslint/no-unused-vars */
        onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, 
        /* eslint-enable @typescript-eslint/no-unused-vars */
        otherProps = __rest(_a, ["text", "icon", "iconPosition", "children", "closeOnSelect", "compact", "containerClassName", "fullscreenCloseText", "menuPlacement", "tooltip", "onFocus", "onBlur", "onClick"]);
        var isOpen = this.state.isOpen;
        var buttonProps = __assign({ active: isOpen, "aria-controls": this.menuId, "aria-expanded": isOpen, "aria-haspopup": true, icon: icon
                ? icon
                : isOpen
                    ? components_1.GKIconName.ArrowDropUp
                    : components_1.GKIconName.ArrowDropDown, iconPosition: icon ? iconPosition : "after", id: this.buttonId, onBlur: this.onButtonBlur, onClick: this.toggleOpen, onFocus: this.onButtonFocus, ref: this.buttonRef, size: this.props.size, tooltip: tooltip }, otherProps);
        return (React.createElement("div", { id: this.containerId, className: "gk-menu-container " + (containerClassName || ""), onBlur: this.onContainerBlur, onMouseDown: this.generalMouseDown, onClick: this.generalClick, ref: this.containerRef },
            React.createElement(components_1.GKButton, __assign({}, (0, common_1.mapDefaultProps)(buttonProps, {
                _gkComponentName: "gk-menu-button",
            })), text || null),
            React.createElement(components_1.GKMenu, { id: this.menuId, "data-qa": this.menuQaTag, isOpen: isOpen, onClose: this.onClosed, onOpen: this.onOpened, anchorRef: this.containerRef, autoFocus: false, ref: this.menuRef, placement: menuPlacement, closeOnSelect: closeOnSelect, compact: compact, fullscreenCloseText: fullscreenCloseText }, children)));
    };
    GKMenuButton.contextType = common_1.WindowSizeContext;
    return GKMenuButton;
}(common_1.GKPureComponent));
exports.GKMenuButton = GKMenuButton;
exports.default = GKMenuButton;
